import { render, staticRenderFns } from "./AcompanhamentoAcoes.vue?vue&type=template&id=8fe293d2"
import script from "./AcompanhamentoAcoes.vue?vue&type=script&lang=js"
export * from "./AcompanhamentoAcoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports